import { render, staticRenderFns } from "./HouseTypeManage.vue?vue&type=template&id=b2400864&scoped=true&"
import script from "./HouseTypeManage.vue?vue&type=script&lang=js&"
export * from "./HouseTypeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2400864",
  null
  
)

export default component.exports